import React, { useState, useEffect } from 'react';
import { Checkbox, Divider, Button } from 'antd';
import MyButton from '../components/Button';
import Typography from '../components/Typography';
import { COLORS } from '../constants/Colors';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import PrivacyPolicyModal from '../containers/PrivacyPolicyModal';
import { CORPORATE_TYPE, INDIVIDUAL_TYPE } from '../constants';
import { FormattedMessage } from 'react-intl';

const SignUpFooter = (props) => {
  const {
    onSubmit,
    onCancel,
    onBack,
    onAcceptPolicy,
    type,
    name,
    selectCustomerType,
    taxNo,
    phone,
    password,
    passwordCf,
    contact,
    email,
    acceptPolicy,
    errorValidate,
    setName,
    setPhone,
    setEmail,
    setPassword,
    setPasswordCf,
    setAcceptPolicy,
    setErrorValidate,
    setAddress,
    setContact,
    setTaxNo,
    setIsCheck,
    setErrorValidatePassword,
    errorValidatePassword,
    isCheck,
  } = props;
  const [isOpenPrivacyPolicy, setIsOpenPrivacyPolicy] = useState(false);
  const [isSubmitVisible, setIsSubmitVisible] = useState(false);
  const isDesktop = useIsDesktop;
  const Lang = localStorage.getItem('lang');

  useEffect(() => {
    if (type === INDIVIDUAL_TYPE) {
      //console.log('acceptPolicy = ', acceptPolicy);
      if (
        name === '' ||
        phone.length < 10 ||
        password.length < 6 ||
        passwordCf === '' ||
        errorValidate !== '' ||
        password !== passwordCf ||
        acceptPolicy === false ||
        acceptPolicy === null ||
        acceptPolicy === undefined
      ) {
        setIsSubmitVisible(true);
      } else {
        setIsSubmitVisible(false);
      }
    } else {
      if (
        name === '' ||
        selectCustomerType === '' ||
        taxNo === '' ||
        phone === '' ||
        contact === '' ||
        email === '' ||
        errorValidate !== '' ||
        acceptPolicy === false ||
        acceptPolicy === null ||
        acceptPolicy === undefined
      ) {
        setIsSubmitVisible(true);
      } else {
        setIsSubmitVisible(false);
      }
    }
  }, [acceptPolicy, isCheck, errorValidatePassword]);

  const handleOpenPrivacyPolicy = () => {
    //console.log('handleOpenPrivacyPolicy');
    setIsOpenPrivacyPolicy(true);
    setIsCheck((prev) => !prev);
  };

  const onGoBack = () => {
    setName('');
    setPhone('');
    setEmail('');
    setPassword('');
    setPasswordCf('');
    setAcceptPolicy('');
    setErrorValidate('');
    setAddress('');
    setContact('');
    setTaxNo('');
    onBack();
  };

  return (
    <div className='d-flex flex-column pt-4'>
      <div className='d-flex flex-row align-items-center'>
        <Checkbox checked={acceptPolicy} value={acceptPolicy} onChange={onAcceptPolicy} />
        <Typography className='pl-2'>
          {Lang === 'TH' ? (
            <>
              <FormattedMessage id='labelPrivacyCheckSignup1' defaultMessage='I agree' />
              <span style={{ color: COLORS.Primary, cursor: 'pointer' }} onClick={handleOpenPrivacyPolicy}>
                <FormattedMessage id='labelPrivacyPolicy' defaultMessage='Privacy Policy' />
              </span>
              <FormattedMessage id='labelPrivacyCheckSignup2' defaultMessage='to the Loop Thailand' />
            </>
          ) : (
            <>
              <FormattedMessage id='labelPrivacyCheck' defaultMessage='I agree to the Loop Thailand' />
              {' '}
              <span style={{ color: COLORS.Primary, cursor: 'pointer' }} onClick={handleOpenPrivacyPolicy}>
                <FormattedMessage id='labelPrivacyPolicy' defaultMessage='Privacy Policy' />
              </span>
              .
            </>
          )}
          
        </Typography>
      </div>
      <Divider />
      <div className={`d-flex ${isDesktop ? 'flex-nowrap ' : 'flex-wrap'}`}>
        <MyButton className={`w-100 ${isDesktop ? 'mx-2' : 'my-2'}`} onClick={onCancel}>
          <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
        </MyButton>
        <MyButton className='w-100' onClick={onGoBack}>
          <FormattedMessage id='btnBack' defaultMessage='Back' />
        </MyButton>
        <MyButton isPrimary className={`w-100 ${isDesktop ? 'mx-2' : 'my-2'}`} onClick={onSubmit} disabled={isSubmitVisible}>
          <FormattedMessage id='btnSubmit' defaultMessage='Submit' />
        </MyButton>
        <PrivacyPolicyModal
          isOpen={isOpenPrivacyPolicy}
          onCancle={() => {
            setIsOpenPrivacyPolicy(false);
          }}
          onAcceptPolicy={onAcceptPolicy}
        />
      </div>
    </div>
  );
};

const SignUp = (props) => {
  const { children } = props;

  const isDesktop = useIsDesktop();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '8px',
        backgroundColor: 'white',
        padding: '24px',
        maxHeight: 'calc(100vh - 160px)',
        overflow: 'auto',
        // justifyContent: "center",
        justifyContent: 'center',
        width: !isDesktop ? 'auto' : '500px',
      }}
    >
      <div className='d-flex flex-column h-100'>
        <Typography isBold color={COLORS.Primary} className='text-left'>
          <FormattedMessage id='btnSignUp' defaultMessage='Sign Up' />
        </Typography>
        <Divider className='my-3' />
        {children}
        <SignUpFooter {...props} />
      </div>
    </div>
  );
};

export default SignUp;
